import React from 'react';
import { Typography, Box } from '@mui/material';
import { colors, fonts } from '../../../constants';

/**
 * EditQueryFieldLabel Component
 * Reusable field label with optional required indicator for EditQueryModal
 * 
 * @param {string} label - Label text
 * @param {boolean} required - Whether field is required
 */
const EditQueryFieldLabel = ({ label, required = false }) => (
  <Typography
    variant="body2"
    sx={{
      fontSize: fonts.fontSizeSm,
      fontWeight: fonts.weightSemiBold,
      color: colors.textPrimaryDark,
      mb: '4px',
      display: 'block',
      lineHeight: 1.4,
      letterSpacing: '0.01em',
    }}
  >
    {label}
    {required && (
      <Box component="span" sx={{ color: colors.error, ml: '4px' }}>
        *
      </Box>
    )}
  </Typography>
);

export default EditQueryFieldLabel;
